/* eslint-disable @typescript-eslint/no-unused-expressions */
import { alpha } from "@mui/material";

export const grey = {
    0: '#FFFFFF',
    100: '#F3F8FB',
    200: '#E1ECF4',
    300: '#CEDBE4',
    400: '#A7BDCD',
    500: '#718EA3',
    600: '#251E1E',
    700: '#364657',
    800: '#0D1E30',
    900: '#08131F',
};

export const action = {
    hover: alpha(grey[500], 0.08),
    selected: alpha(grey[500], 0.16),
    disabled: alpha(grey[500], 0.8),
    disabledBackground: alpha(grey[500], 0.24),
    focus: alpha(grey[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
};

export const useDynamicPalette = (mode: 'light' | 'dark', theme?: any) => {

    const base = {
        mainBanners: theme?.mainBanners,
        primaryButtons: theme?.primaryButtons,
        homePage: theme?.homePage,
        action
    }

    const light = {
        ...base,
        mode: 'light',
        text: {
            primary: grey[800],
            secondary: grey[600],
            disabled: grey[500],
        },
        background: {
            paper: '#FFFFFF',
            default: '#FFFFFF',
            neutral: grey[100],
        },
        action: {
            ...base.action,
            active: grey[600],
        },
    };

    const dark = {
        ...base,
        mode: 'dark',
        text: {
            primary: '#FFFFFF',
            secondary: grey[500],
            disabled: grey[600],
        },
        background: {
            paper: grey[800],
            default: grey[900],
            neutral: alpha(grey[500], 0.16),
        },
        action: {
            ...base.action,
            active: grey[500],
        },
    };

    return mode === 'light' ? light : dark;
}